export default __webpack_public_path__ + "static/media/f9.2025a2cf.jpg";